'use strict';

const Backbone = require('backbone/backbone');
const _ = require('underscore/underscore');

require('./IndexHero.less');

module.exports = Backbone.View.extend({

    el: '.IndexHero',

    events: {
        'click .IndexHero-contour svg': 'onContourClick'
    },

    initialize: function () {
        _.bindAll(this, 'onImageLoad');

        this.indexHeroImage = this.$('.IndexHero-image')[0];

        window.app.vent.on('image-loaded', this.onImageLoad);
    },

    onImageLoad: function (node) {
        if (node === this.indexHeroImage) {
            window.app.vent.off('image-loaded', this.onImageLoad);
            this.$('.IndexHero-wire').css('opacity', 1);
        }
    },

    onContourClick: function () {
        app.vent.trigger('contour-click');
    }
});
